import { useMemo } from "react";
import { useInitialContext } from "../context/useInitialContext";
import IFormType from "../../interfaces/IFormType";

export type IUseFormTypeListHook = () => {
    data: IFormType[];
    fetching: boolean;
}

export const useFormTypeList: IUseFormTypeListHook = () => {
    const { data: { formTypes: rawData }, fetching } = useInitialContext();
    return useMemo(() => ({ data: rawData, fetching, }), [rawData, fetching]);
};
